import { render, staticRenderFns } from "./ReceberNotasManifesto.vue?vue&type=template&id=2915f8bf"
import script from "./ReceberNotasManifesto.vue?vue&type=script&lang=js"
export * from "./ReceberNotasManifesto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports